const comparisonData = [
  { feature: 'Product Prices', vigorbuy: 'Lower, direct from source', traditional: 'Higher retail markups' },
  { feature: 'Quality Control', vigorbuy: 'QC photos before shipping', traditional: 'No pre-shipment QC' },
  { feature: 'Seller Selection', vigorbuy: 'Thousands of verified sellers', traditional: 'Limited brand options' },
  { feature: 'Shipping Options', vigorbuy: 'Flexible worldwide routes', traditional: 'Fixed carrier options' },
  { feature: 'Product Variety', vigorbuy: 'Shoes, clothing, bags & more', traditional: 'Category restrictions' },
  { feature: 'Update Frequency', vigorbuy: 'Updated daily with new links', traditional: 'Seasonal catalog updates' },
];

export default function ComparisonTable() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Why Use a <span className="text-accent-500">VigorBuy Spreadsheet</span>?
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-2xl mx-auto">
            A <strong>VigorBuy Spreadsheet</strong> helps buyers discover trusted products, compare prices, and access reliable sellers faster. Instead of spending hours searching manually, browse categorized links with product information, seller ratings, and QC references.
          </p>
        </div>

        {/* Table */}
        <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
          {/* Header */}
          <div className="grid grid-cols-3 bg-foreground-900 text-background-50">
            <div className="p-4 text-sm font-semibold">Feature</div>
            <div className="p-4 text-sm font-semibold text-center">
              <span className="text-accent-500">VigorBuy Spreadsheet</span>
            </div>
            <div className="p-4 text-sm font-semibold text-center">Traditional Shopping</div>
          </div>

          {/* Rows */}
          {comparisonData.map((row, i) => (
            <div
              key={row.feature}
              className={`grid grid-cols-3 border-b border-background-200/70 ${
                i % 2 === 0 ? 'bg-background-50' : 'bg-background-100'
              }`}
            >
              <div className="p-4 text-sm font-medium text-foreground-700">{row.feature}</div>
              <div className="p-4 text-sm text-accent-700 text-center font-medium">{row.vigorbuy}</div>
              <div className="p-4 text-sm text-foreground-400 text-center">{row.traditional}</div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
          >
            Start Browsing the Spreadsheet <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}